import React, { useState } from "react";
import { Download, FileText, Image as ImageIcon, Loader2 } from "lucide-react";

const TABS = [
  { key: "png", label: "Imagen (PNG)", icon: ImageIcon },
  { key: "pdf", label: "Documento (PDF)", icon: FileText },
];

const withInline = (url) => `${url}${url.includes("?") ? "&" : "?"}inline=1`;

export const FlowDocumentViewer = ({ pngUrl, pdfUrl }) => {
  const [tab, setTab] = useState("png");
  const [loaded, setLoaded] = useState(false);
  const urls = { png: pngUrl, pdf: pdfUrl };
  return (
    <section className="border border-slate-200 bg-white" data-testid="flow-document-viewer">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 px-4 py-3">
        <div className="flex gap-1">
          {TABS.map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-[10px] uppercase tracking-[0.18em] transition-colors ${
                tab === key ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"
              }`}
              data-testid={`flow-tab-${key}`}
            >
              <Icon className="h-3 w-3" /> {label}
            </button>
          ))}
        </div>
        <a
          href={urls[tab]}
          download
          className="inline-flex items-center gap-1.5 border border-slate-900 px-3 py-1.5 text-[10px] uppercase tracking-[0.18em] text-slate-900 hover:bg-slate-100"
          data-testid="flow-download-btn"
        >
          <Download className="h-3 w-3" /> Descargar {tab.toUpperCase()}
        </a>
      </div>
      {tab === "png" ? (
        <div className="max-h-[75vh] overflow-auto bg-slate-50 p-4" data-testid="flow-png-frame">
          {!loaded && (
            <p className="flex items-center gap-2 py-10 text-sm text-slate-400">
              <Loader2 className="h-4 w-4 animate-spin" /> Generando el documento de flujo…
            </p>
          )}
          <img
            src={withInline(pngUrl)}
            alt="Flujo de actividades ABC"
            onLoad={() => setLoaded(true)}
            className={`mx-auto w-full max-w-4xl ${loaded ? "" : "hidden"}`}
            data-testid="flow-png-image"
          />
        </div>
      ) : (
        <iframe
          title="Flujo de actividades (PDF)"
          src={withInline(pdfUrl)}
          className="h-[75vh] w-full"
          data-testid="flow-pdf-frame"
        />
      )}
    </section>
  );
};
